module.exports = __webpack_public_path__ + "static/img/login_headerja.d49eb55.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login2/login_headerja.png
// module id = mMqn
// module chunks = 0